<!-- Bloc de gauche -->
<ng-container *ngIf="bloc === 'gauche'">
    <div>
        <div class="grid justify-items-center">
            <div class="font-medium mb-5 text-center text-secondary">
                <div translate>lingueopro.dashboard.upcoming_sessions.Passage du LILATE</div>
            </div>

            <div *ngIf="isPendingAssessment" translate>
                lilate-exam.session-content.isPendingAssessment
            </div>

            <div *ngIf="lilate?.targeted_level" class="mt-2">
                <span translate>examination.informations.targeted-level-label</span>
                <span class="font-medium" *ngIf="!shouldShowOtherLevel()"> {{ lilate.targeted_level }}</span>
                <span class="font-medium" *ngIf="shouldShowOtherLevel()" translate> targeted-level-form.other_level</span>
            </div>

            <div class="font-extrabold text-2xl">{{ lilate.start | amLocale: 'fr' | amDateFormat:'dddd DD MMMM' }}</div>
            <div class="font-extrabold text-2xl"
                [translateParams]="{start: lilate.start | amLocale: getCurrentLanguage() | amDateFormat:'HH:mm', end: lilate.end | amLocale: getCurrentLanguage() | amDateFormat:'HH:mm'}"
                translate>lingueopro.plan-formation.conclusion.date-slot-time
            </div>
            <div>
                <span [innerHTML]="countdownStatus | translate"> </span> 
                <span *ngIf="!isPendingAssessment"> {{countdown}} :</span>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!isPendingAssessment">
        <button [disabled]="!providerRequirements" (click)="openTeamsLink()"
            [ngClass]="{'bg-gray-300': !providerRequirements, 'text-green-100': providerRequirements, 'bg-green-500': providerRequirements}"
            class="w-full mt-10 md:mt-auto defaut-btn">
            <span translate>lilate-exam.session-content.join
            </span>
        </button>
        <div class="booked-guidance" *ngIf="lilate.status === 'identity_issue'" translate>
            lilate-exam.session-content.identity_issue
        </div>
    </ng-container>

    <div class="grid justify-items-start mt-5">
        <button [disabled]="isCancellationLocked()" (click)="changeDateLilate(lilate)"
            [ngClass]="{'bg-gray-300': isCancellationLocked(), 'text-green-100': !isCancellationLocked(), 'bg-green-500': !isCancellationLocked()}"
            class="w-full  mt-10 md:mt-auto defaut-btn">
            <span translate>lilate-exam.session-content.change-date</span>
        </button>

        <button [disabled]="isLessThan1Hour()" (click)="navigateToEditTargetedLevel(lilate.id)"
            [ngClass]="{'bg-gray-300': isLessThan1Hour(), 'text-green-100': !isLessThan1Hour(), 'bg-green-500': !isLessThan1Hour()}"
            class="w-full mt-5 defaut-btn">
            <span translate>lilate-exam.session-content.edit-targeted-level</span>
        </button>
    </div>
</ng-container>


<!-- bloc de droite -->
<ng-container *ngIf="bloc === 'droite'">
    <!-- LILATE EN COURS -->
    <div class="mt-2 leading-relaxed text-secondary">
        <div *ngIf="(lilate.status == 'booked' || lilate.status == 'identity_issue') && !isPendingAssessment">
            <div translate class="mt-10 text-xl" *ngIf="!providerRequirements">
                lilate-exam.session-content.booked-guidance
            </div>
        </div>
    </div>

    <div class="flex items-center mt-10">
        <div class="font-medium text-secondary" translate>lilate.prep.testHeading</div>
    </div>
    <!-- Features -->
    <div class="grid grid-cols-1 gap-y-4 mt-5">
        <div class="flex items-center">
            <mat-icon class="icon-size-5">
                <svg id="arrow-circle-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clip-rule="evenodd"/>
                </svg>
            </mat-icon>
            <div class="ml-2" translate>lilate.prep.idRequirement</div>
        </div>

        <div class="flex items-center">
            <mat-icon class="icon-size-5">
                <svg id="arrow-circle-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clip-rule="evenodd"/>
                </svg>
            </mat-icon>
            <div class="ml-2" translate>lilate.prep.browserRequirement</div>
        </div>

        <div class="flex items-center">
            <mat-icon class="icon-size-5">
                <svg id="arrow-circle-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clip-rule="evenodd"/>
                </svg>
            </mat-icon>
            <div class="ml-2" translate>lilate.prep.testEnvironment</div>
        </div>

        <div class="flex items-center">
            <mat-icon class="icon-size-5">
                <svg id="arrow-circle-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clip-rule="evenodd"/>
                </svg>
            </mat-icon>
            <div class="ml-2 underline cursor-pointer" (click)="openSetupMedia()" translate>lilate.prep.checkMedia</div>
        </div>
    </div>
</ng-container>